import { SubscriptionType } from "../types/company";
import { SubscriptionActions } from "../types/user";
import { ProtectedRoutes } from "./routes.utils";

export const AvailableStandardActions: SubscriptionActions[] = [
  SubscriptionActions.ACTION_PLAN,
  SubscriptionActions.LAUNCH_SURVEY,
  SubscriptionActions.HR_INTEGRATION,
  SubscriptionActions.TEAM_MEMBERS,
];

export const AvailableTrainingActions: SubscriptionActions[] = [
  SubscriptionActions.ACTION_PLAN,
  SubscriptionActions.TEAM_MEMBERS,
];

export const AvailablePreviewActions: SubscriptionActions[] = [];

// Map of subscription types to their available actions
const SUBSCRIPTION_PERMISSIONS: Record<
  SubscriptionType,
  SubscriptionActions[]
> = {
  [SubscriptionType.PREVIEW]: AvailablePreviewActions,
  [SubscriptionType.TRAINING]: AvailableTrainingActions,
  [SubscriptionType.STANDARD]: AvailableStandardActions,
  [SubscriptionType.TRIAL]: AvailableStandardActions,
};

// Get all available actions for given subscription types
export const getAvailableActions = (
  subscriptionTypes: SubscriptionType[]
): SubscriptionActions[] => {
  const actionsSet = new Set<SubscriptionActions>();

  subscriptionTypes.forEach((type) => {
    SUBSCRIPTION_PERMISSIONS[type]?.forEach((action) => {
      actionsSet.add(action);
    });
  });

  return Array.from(actionsSet);
};

// Check if subscription types have access to a specific action
export const hasSubscriptionAccess = (
  subscriptionTypes: SubscriptionType[],
  action: SubscriptionActions
): boolean => {
  const availableActions = getAvailableActions(subscriptionTypes);
  return availableActions.includes(action);
};

// Get the default route based on subscription types
export const getDefaultRoute = (
  subscriptionTypes: SubscriptionType[] = []
): string => {
  if (subscriptionTypes.includes(SubscriptionType.TRAINING)) {
    return ProtectedRoutes.TRAINING;
  }
  return ProtectedRoutes.DASHBOARD;
};

export const getDefaultLoginRoute = (
  subscriptionTypes: SubscriptionType[] = [],
  pathname?: string
): string => {
  if (subscriptionTypes.includes(SubscriptionType.TRAINING)) {
    return ProtectedRoutes.TRAINING;
  } else return pathname || ProtectedRoutes.DASHBOARD;
};
